import { render, staticRenderFns } from "./HomeHionSocio.vue?vue&type=template&id=b0fa1de2&"
import script from "./HomeHionSocio.vue?vue&type=script&lang=js&"
export * from "./HomeHionSocio.vue?vue&type=script&lang=js&"
import style0 from "./HomeHionSocio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports